import { graphql } from "react-relay";

export const VIDEO_ELEMENT_FRAGMENT = graphql`
	fragment videoElementForm_VideoElementFragment on VideoElement {
		id
		title
		availableSourceTypes
		videoSource {
			sourceType
			... on VimeoVideoElementSourceV2 {
				vimeoId
				vimeoVideoSource {
					id
				}
			}
			... on S3VideoElementSourceV2 {
				folder
			}
		}
	}
`;

export const EDIT_VIDEO_ELEMENT_MUTATION = graphql`
	mutation videoElementForm_EditVideoElementMutation($input: EditVideoElementV2Input!) {
		Admin {
			ElearningV2 {
				editVideoElement(input: $input) {
					videoElement {
						...videoElementForm_VideoElementFragment
					}
				}
			}
		}
	}
`;

export const EDIT_S3_VIDEO_ELEMENT_MUTATION = graphql`
	mutation videoElementForm_EditS3VideoElementMutation($input: EditS3VideoElementV2Input!) {
		Admin {
			ElearningV2 {
				editS3VideoElement(input: $input) {
					videoElement {
						...videoElementForm_VideoElementFragment
					}
				}
			}
		}
	}
`;
